import React from 'react'
import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
import { Redirect } from 'react-router-dom'
import { scrollTop } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { AppView, AppContainer, AppHeader, AppContent, AppLogo } from '@brainstud/react-tbl/themes/pgw/v1/components/layout'
import { Animation, Page, PageHeader } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import PageType from '@brainstud/react-tbl/features/pages/views/types'
import { withPage } from '@brainstud/react-tbl/themes/pgw/v1/containers'

class PageView extends React.Component {
  componentDidMount() {
    scrollTop()
    this.setTheme()
    this.props.app.setLocation({ label: 'page', id: this.props.page.id })
  }

  setTheme() {
    this.props.app.triggerTheme(this.props.page.navigation.theme || 'default')
  }

  updateProgress = () => {
    if (this.props.page.navigation.progress.status !== 'done') {
      this.props.setNavigationProgress({
        id: this.props.page.navigation.id,
        data: {
          ...this.props.page.navigation.progress,
          progress: 1,
          status: 'done',
        }
      })
      this.props.app.willProgress(this.props.page.navigation.prefix)
    }
  }

  handleSubmit = e => {
    this.updateProgress()

    this.props.history.push(Routes.to('home'))
  }

  render() {
    if (this.props.page.id) {
      return (
        <AppView name={`Page Page-${this.props.page.slug}`}>
          {(!this.props.page.headerType || this.props.page.headerType === 'default') &&
            <AppHeader />
          }

          <AppContent>
            <Page container>
              {this.props.page.headerType === 'simple' &&
                <Animation name="zoomIn">
                  <PageHeader>
                    <AppLogo />
                  </PageHeader>
                </Animation>
              }

              <PageType
                match={this.props.match}
                location={this.props.location}
                page={this.props.page}
                onSubmit={this.handleSubmit}
                updateProgress={this.updateProgress}
                user={this.props.user} />
            </Page>
          </AppContent>
        </AppView>
      )
    }

    else {
      return <Redirect to={Routes.to('home')} />
    }
  }
}

export default withPage(PageView)
